export default __webpack_public_path__ + "static/media/checkboxOff.a8fffa4a.svg";